import * as React from "react";
import { ArrowRight, Sparkles, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function JoinTheMovement() {
  return <section data-section-id="244293" id="partner-with-afrex" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32 flex items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,hsl(var(--primary)/0.15)_0%,transparent_60%)] rounded-lg blur-3xl opacity-70" />
      </div>

      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,hsl(var(--primary)/0.1)_1px,transparent_1px),linear-gradient(to_bottom,hsl(var(--primary)/0.1)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center">
        {}
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 border border-primary/20 text-primary mb-8">
          <Users className="w-4 h-4" />
          <span className="text-sm font-medium tracking-wide">
            Global Network of Strategic Partners
          </span>
        </div>

        {}
        <h2 className="font-default text-5xl md:text-7xl font-bold tracking-tighter mb-6 text-balance">
          Ready to Expand Your Reach?
        </h2>

        {}
        <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mb-12 text-balance">
          Join AFREX INTEGRATED GROUP to leverage our multi-country platform. We connect global manufacturers with high-impact trade opportunities across the USA, Kenya, and Guinea.
        </p>

        {}
        <div className="relative group inline-block">
          {}
          <Sparkles className="absolute -top-6 -left-6 h-8 w-8 text-primary opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 delay-75 rotate-12" />
          <Sparkles className="absolute -bottom-4 -right-8 h-6 w-6 text-primary opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 delay-150 -rotate-12" />
          <Sparkles className="absolute top-1/2 -right-10 h-5 w-5 text-primary opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 delay-300" />
          <Sparkles className="absolute -bottom-8 left-4 h-4 w-4 text-primary opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500 delay-200" />

          {}
          <div className="absolute -inset-1 bg-gradient-to-r from-primary to-primary/50 rounded-lg blur opacity-30 group-hover:opacity-70 transition duration-500 group-hover:duration-200" />

          <Button size="lg" className="relative text-lg px-10 py-7 h-auto rounded-md shadow-xl hover:shadow-2xl transition-all duration-300 group-hover:-translate-y-1 bg-primary text-primary-foreground hover:bg-primary/90 border border-primary-foreground/10" asChild>
            <Link to="/ContactPage">
              <span className="font-semibold tracking-wide">Initiate Partnership</span>
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
          </Button>
        </div>
        
        <p className="mt-6 text-sm text-muted-foreground/60">
          Built to support manufacturers, institutional buyers, development partners, and project operators across key markets.
        </p>
      </div>
    </section>;
}